import React from "react";
import { Tooltip } from "antd";
import { ReactComponent as CopyIcon } from "resources/icons/copyicon.svg";
import { ReactComponent as Thumbsup } from "resources/icons/ThumbsUp.svg";
import { ReactComponent as Thumbsdown } from "resources/icons/ThumbsDown.svg";
import { ReactComponent as SelectedCopy } from "resources/icons/SelectedCopy.svg";
import { ReactComponent as SelectedLike } from "resources/icons/SelectedThumbsUp.svg";
import { ReactComponent as SelectedDisLike } from "resources/icons/SelectedThumbsDown.svg";

import "./index.scss";
const CopyLikeDislikeIcons = ({
  reaction,
  handleCopy,
  handleLike,
  handleDislike,
  copyTooltipVisible,
  likeTooltipVisible,
  dislikeTooltipVisible,
}) => {
  return (
    <div className="nova-chat-hover-icons">
      <Tooltip open={copyTooltipVisible}>
        {copyTooltipVisible ? (
          <SelectedCopy
            className="cursor-pointer nova-copy-icon-clicked"
            title="Copied!"
            onClick={handleCopy}
          />
        ) : (
          <CopyIcon
            className="cursor-pointer mt-2 nova-copy-icon"
            title="Copy"
            onClick={handleCopy}
          />
        )}
      </Tooltip>

      {reaction !== "dislike" && (
        <Tooltip open={likeTooltipVisible}>
          {reaction === "like" ? (
            <SelectedLike
              className="cursor-pointer"
              title="Thanks for your feedback!"
              fill="#FFA500"
            />
          ) : (
            <Thumbsup
              className="cursor-pointer"
              title="Like"
              onClick={handleLike}
              fill="#FFA500"
            />
          )}
        </Tooltip>
      )}

      {reaction !== "like" && (
        <Tooltip open={dislikeTooltipVisible}>
          {reaction === "dislike" ? (
            <SelectedDisLike
              className="cursor-pointer"
              title="Tell us Why!"
              fill="#FFA500"
            />
          ) : (
            <Thumbsdown
              className="cursor-pointer"
              title="Tell us Why!"
              onClick={handleDislike}
              fill="#FFA500"
            />
          )}
        </Tooltip>
      )}
    </div>
  );
};

export default CopyLikeDislikeIcons;
